const header = document.querySelector('.mp-header');

if (header) {
  const drawer = header.querySelector('.mp-header__drawer');
  const summary = drawer?.querySelector('summary');
  const drawerPanel = drawer?.querySelector('.mp-header__drawer-panel');
  const drawerSearch = drawer?.querySelector('#MicroportMobileProductSearch');
  const closeButtons = drawer?.querySelectorAll('[data-mp-header-close]');
  const productsMenu = header.querySelector('.mp-header__products-menu');
  const isolationTargets = [
    ...document.querySelectorAll('main, footer'),
    ...header.querySelectorAll('.mp-header__brand, .mp-header__desktop-nav, .mp-header__search, .mp-header__store'),
  ];

  const setDrawerIsolation = (isOpen) => {
    isolationTargets.forEach((target) => { target.inert = isOpen; });
    if (summary) summary.inert = isOpen;
  };

  const closeDrawer = ({ returnFocus = false } = {}) => {
    if (!drawer) return;
    const wasOpen = drawer.open;
    setDrawerIsolation(false);
    drawer.removeAttribute('open');
    summary?.setAttribute('aria-expanded', 'false');
    if (wasOpen && returnFocus) summary?.focus();
  };

  drawer?.addEventListener('toggle', () => {
    summary?.setAttribute('aria-expanded', drawer.open ? 'true' : 'false');
    document.body.classList.toggle('mp-header-drawer-open', drawer.open);
    if (drawer.open) {
      setDrawerIsolation(true);
      window.requestAnimationFrame(() => drawerSearch?.focus());
    } else {
      setDrawerIsolation(false);
    }
  });

  closeButtons?.forEach((button) => {
    button.addEventListener('click', () => closeDrawer({ returnFocus: true }));
  });

  drawer?.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('a[href]')) closeDrawer();
  });

  document.addEventListener('click', (event) => {
    if (productsMenu?.open && event.target instanceof Node && !productsMenu.contains(event.target)) {
      productsMenu.removeAttribute('open');
    }
  });

  productsMenu?.addEventListener('toggle', () => {
    const productsSummary = productsMenu.querySelector('summary');
    productsSummary?.setAttribute('aria-expanded', productsMenu.open ? 'true' : 'false');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const drawerWasOpen = drawer?.open;
      closeDrawer({ returnFocus: Boolean(drawerWasOpen) });
      header.querySelector('.mp-header__products-menu[open]')?.removeAttribute('open');
      return;
    }

    if (event.key !== 'Tab' || !drawer?.open) return;
    const focusable = Array.from(
      drawerPanel?.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), summary') || []
    ).filter((element) => element instanceof HTMLElement && element.getClientRects().length > 0 && !element.closest('[inert]'));
    const first = focusable[0];
    const last = focusable.at(-1);
    if (!(first instanceof HTMLElement) || !(last instanceof HTMLElement)) return;
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
}
